import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const FiltrosProveedor = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const [nombre, setNombre] = useState('');
    const [contacto, setContacto] = useState('');

    useEffect(() => {
        if (show) {
            setNombre(filtros.nombre || '');
            setContacto(filtros.contacto || '');
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            nombre: nombre.trim(),
            contacto: contacto.trim()
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setNombre('');
        setContacto('');
        handleAplicar({ nombre: '', contacto: '' });
        handleCerrar();
    };

    return (
        <Modal show={show} size="md" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    <div className="col-6">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                id="filtro_nombre"
                                value={nombre}
                                onChange={e => setNombre(e.target.value)}
                            />
                            <label htmlFor="filtro_nombre">Nombre</label>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Contacto"
                                id="filtro_contacto"
                                value={contacto}
                                onChange={e => setContacto(e.target.value)}
                            />
                            <label htmlFor="filtro_contacto">Contacto</label>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosProveedor;
